const getDefaultState = () => {
  return {
    videoPlayer: true,
    liveState: 1,
    initGood: false
  }
}
const state = getDefaultState()
const actions = {

}
const mutations = {
  SET_VIDEOPLAYER (state, status) {
    state.videoPlayer = status
  },
  SET_LIVESTATE (state, status) {
    state.liveState = status
  },
  SET_INITGOOD (state, status) {
    state.initGood = status
  }
}
export default {
  namespaced: true,
  actions,
  mutations,
  state
}
